import { combineReducers } from 'redux'
import loader from './loader';
import userdata from './userdata';

export default combineReducers({
  loader, userdata
})
